var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.theme.alertIcon
  }, [_c('v-font-icon', {
    class: _vm.theme.icon
  }, [_vm._v("\n            " + _vm._s(_vm.icon) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.alertContent
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c3382b7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Alert/Alert.vue
// module id = 469
// module chunks = 0